import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { SDKs } from "components/Docs/Integrate";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Custom-built libraries for integrating PostHog with popular client and server-side langauges.`}</p>
    <SDKs mdxType="SDKs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      